const ReportAndAnalyticsActiveIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6673 1.83301H1.33398C1.06065 1.83301 0.833984 1.60634 0.833984 1.33301C0.833984 1.05967 1.06065 0.833008 1.33398 0.833008H14.6673C14.9407 0.833008 15.1673 1.05967 15.1673 1.33301C15.1673 1.60634 14.9407 1.83301 14.6673 1.83301Z"
        fill="#F6FCFF"
      />
      <path
        d="M11.1135 14.893C11.0268 15.0663 10.8468 15.1663 10.6668 15.1663C10.5935 15.1663 10.5135 15.1463 10.4468 15.113L8.00017 13.893L5.55351 15.113C5.48684 15.1463 5.40684 15.1663 5.33351 15.1663C5.15351 15.1663 4.97351 15.0663 4.88684 14.893C4.76017 14.6397 4.86017 14.3397 5.11351 14.2197L7.50017 13.0263V11.333H8.50017V13.0263L10.8868 14.2197C11.1402 14.3397 11.2402 14.6397 11.1135 14.893Z"
        fill="#F6FCFF"
      />
      <path
        d="M2 1.33301V9.39968C2 10.6663 2.66667 11.333 3.93333 11.333H12.0667C13.3333 11.333 14 10.6663 14 9.39968V1.33301H2ZM11.32 5.71967L9.22 7.47301C9.02667 7.63301 8.78 7.69967 8.54667 7.65967C8.30667 7.61967 8.1 7.47301 7.97333 7.25968L7.27333 6.09301L5.32 7.71967C5.22667 7.79967 5.11333 7.83301 5 7.83301C4.86 7.83301 4.71333 7.77301 4.61333 7.65301C4.43333 7.43967 4.46667 7.12634 4.68 6.94634L6.78 5.19301C6.97333 5.03301 7.22 4.96634 7.45333 5.00634C7.69333 5.04634 7.9 5.19301 8.02667 5.40634L8.72667 6.57301L10.68 4.94634C10.8933 4.76634 11.2067 4.79967 11.3867 5.01301C11.56 5.22634 11.5333 5.53967 11.32 5.71967Z"
        fill="#F6FCFF"
      />
    </svg>
  );
};

export default ReportAndAnalyticsActiveIcon;
